module.exports = __webpack_public_path__ + "img/09.42b70177.jpg";